const Window = {
  innerWidth: 0,
  innerHeight: 0,
}
export default Window
